export default "__VITE_ASSET__Yw2pje$7__"